import ajax from '@/api/userApi'
import store from '@/config/config' //vuex

const TYPE_NO = {
    "XM":"/getProjectNo",
    "HD":"/getActivityNo",
    'ZJ':"/getFundNo",
}

export default function getProjectNo(str="XM"){
    return new Promise((resolve,reject)=>{
        ajax.get(store.state.api+TYPE_NO[str],{
            uid:store.state.userInfo.userid,
        }).then(res=>{
            console.log(res['data'])
            if(res['data'][0].length==0||res['data'][0][0]['No']==null)return resolve(`${str}0000001`)
            let LastNo = res['data'][0][0]['No']
            let number = parseInt(LastNo.slice(-7));
            let newNumber = number+1;
            let newNo = `${str}${newNumber.toString().padStart(7,"0")}`;
            resolve(newNo);
        })
    })
}